<rid-multisyllabic-keyboard-direct-rule-application
  class="h-dvh"
  [prompts]="[
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/M5s986gQqZakIAgaz8zlr.mp3',
      },
      answer: ['h', 'e', 'b', 'b', 'sjwa', 'n'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
      },
      answer: ['z', 'e(e)', 'b', 'r', 'a(a)'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/TtAMwyZBE_atG1_bJiHwi.mp3',
      },
      answer: ['p', 'aa', 'r', 'd'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/SnQMAnPY-Nq7oDYZqOuEZ.mp3',
      },
      answer: ['a', 'ch', 't'],
    },
  ]"
  (finished)="$router.navigate(['/mechanics/syllabic-keyboard-plus'])"
/>
